// bm-design-system: progress primitives
// Spinner for indeterminate waits; ProgressBar for determinate progress.
import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: "sm" | "md";
  label?: string;
}

export function Spinner({ size = "sm", label = "Loading", className, ...props }: SpinnerProps) {
  return (
    <span className={cn("inline-flex items-center text-ink-muted", className)} {...props}>
      <Loader2
        aria-hidden="true"
        className={cn("animate-spin", size === "sm" ? "h-4 w-4" : "h-6 w-6")}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 0–100 */
  value: number;
}

export function ProgressBar({ value, className, ...props }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("h-1.5 w-full overflow-hidden rounded-full bg-hairline", className)}
      {...props}
    >
      <div
        className="h-full rounded-full bg-accent transition-[width] duration-300"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
